module.exports = __webpack_public_path__ + "static/media/amm.a099ef0b.png";